import { CompanyDetailSummary } from './CompanyDetailSummary';
import { HeroSection } from './HeroSection';
import { Benefit } from './Benefit';
import { Growthwise } from './Growthwise';
import { Features } from './Features';
import { Platform } from './Platform';
import { Converter } from './Converter';

function Homepage() {
  return (
    <div className='flex flex-col gap-16 font-pin mx-auto'>
      <HeroSection />
      <CompanyDetailSummary />
      <Benefit />
      <Growthwise />
      <Features />
      <Platform />
      {/* <Converter /> */}
    </div>
  );
}
export default Homepage;
